import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useRelatedProperties = (PropertyId: string) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const urlKey = `${t("related-property-list-api")}/${PropertyId}`;

  const { data: relatedPropertyList, refetch } = useQuery({
    queryKey: [`Related-Property-List`, PropertyId],
    queryFn: async () => {
      const res = await axios.get(urlKey);
      return res.data;
    },
    enabled: !!PropertyId,
    staleTime: 0,
    refetchOnMount: true
  });

  return { data: relatedPropertyList?.data, refetch };
};
